var WebhookType = /* @__PURE__ */ ((WebhookType2) => {
  WebhookType2[WebhookType2["DROPPED_TRANSACTION"] = 1] = "DROPPED_TRANSACTION";
  WebhookType2[WebhookType2["MINED_TRANSACTION"] = 2] = "MINED_TRANSACTION";
  WebhookType2[WebhookType2["ADDRESS_ACTIVITY"] = 4] = "ADDRESS_ACTIVITY";
  WebhookType2[WebhookType2["NFT_ACTIVITY"] = 6] = "NFT_ACTIVITY";
  WebhookType2[WebhookType2["NFT_METADATA_UPDATE"] = 7] = "NFT_METADATA_UPDATE";
  WebhookType2[WebhookType2["GRAPHQL"] = 8] = "GRAPHQL";
  WebhookType2[WebhookType2["PENDING_TRANSACTION"] = 0] = "PENDING_TRANSACTION";
  WebhookType2[WebhookType2["DELAYED_TRANSACTION"] = 3] = "DELAYED_TRANSACTION";
  WebhookType2[WebhookType2["GAS_PRICE"] = 5] = "GAS_PRICE";
  return WebhookType2;
})(WebhookType || {});
export {
  WebhookType
};
//# sourceMappingURL=webhook.js.map